import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  Signal1973xs1vkmdcb as Signal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  ProjectState_Terminated_getInstancedn60ew509y4p as ProjectState_Terminated_getInstance,
  ProjectState_Cancelled_getInstanceoirlccakusgk as ProjectState_Cancelled_getInstance,
  ProjectState_Abandoned_getInstance19b47j86nick as ProjectState_Abandoned_getInstance,
  get_entries3onyqwuzh1iwq as get_entries,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { setOf45ia9pnfhe90 as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  toSet2orjxp16sotqu as toSet,
  plus310ted5e4i90h as plus,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { minus165a8u1e0x1lu as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../sdk/UserSession.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  Projecto73xqbcrzskm as Project,
  Contractor1wog4uk4l8u77 as Contractor,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_customer1w9vmrtgthst as get_customer,
  get_isArchived1blzbvus67h1w as get_isArchived,
  get_state23zbf4that7g as get_state,
  get_nameo9a32lyl7xbh as get_name,
} from '../../../../../../crowpay-shared/com/crowpay/ProjectFields.mjs';
import {
  eq1298m2cje971u as eq,
  xDataClassPathInsideSet1u5agsol0s6ul as xDataClassPathInsideSet,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import {
  or1ww9501dfiqpb as or,
  andvtrcuje7baox as and,
} from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Condition.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get__id44zpbhzp4qxe as get__id } from '../../../../../../crowpay-shared/com/crowpay/ContractorFields.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ProjectLens_Customer_getInstancedmuwwz4nvrem as ProjectLens_Customer_getInstance } from '../common/ProjectView.mjs';
import { projectList120z2nvqx0g4u as projectList } from '../../components/project/projectList.mjs';
import { Page1o437w9xuocrm as Page } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ClientProjectsClass;
function ClientProjects() {
  if (ClientProjectsClass === VOID) {
    class $ {
      constructor() {
        this.mj3_1 = new (Constant())(_Constant___init__impl__v45mub('Your Projects'));
        this.nj3_1 = setOf([ProjectState_Terminated_getInstance(), ProjectState_Cancelled_getInstance(), ProjectState_Abandoned_getInstance()]);
        this.oj3_1 = minus(toSet(get_entries()), this.nj3_1);
        this.pj3_1 = Signal().fak(false);
        var tmp = this;
        tmp.qj3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.baj(get_session());
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp_0 = and(eq(get_customer(it), session.efv_1), or(eq(get_isArchived(it), true), xDataClassPathInsideSet(get_state(it), this.nj3_1)));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$5);
          this_0.o4a(get_state(it_0));
          this_0.m4a(get_name(it_0));
          var tmp$ret$10 = this_0.o1r();
          return session.pfv_1.feo(new (Query())(tmp_0, tmp$ret$10));
        });
        var tmp_0 = this;
        tmp_0.rj3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var session = $this$remember.baj(get_session());
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp, KSerializer()) ? tmp : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$11);
          var tmp_0 = and(and(eq(get_customer(it), session.efv_1), eq(get_isArchived(it), false)), xDataClassPathInsideSet(get_state(it), this.oj3_1));
          // Inline function 'com.lightningkite.lightningdb.sort' call
          // Inline function 'kotlin.apply' call
          var this_0 = new (SortBuilder())();
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(Project()), arrayOf([]), false));
          var tmp$ret$16 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          var it_0 = new (DataClassPathSelf())(tmp$ret$16);
          this_0.o4a(get_state(it_0));
          this_0.m4a(get_name(it_0));
          var tmp$ret$21 = this_0.o1r();
          return session.pfv_1.feo(new (Query())(tmp_0, tmp$ret$21));
        });
        var tmp_1 = this;
        tmp_1.sj3_1 = remember(VOID, VOID, VOID, ($this$remember) => plus($this$remember.baj($this$remember.baj(this.rj3_1)), $this$remember.baj(this.pj3_1) ? $this$remember.baj($this$remember.baj(this.qj3_1)) : emptyList()));
        var tmp_2 = this;
        tmp_2.tj3_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).jfv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(Contractor()), arrayOf([]), false));
          var tmp$ret$22 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$22);
          var tmp_1 = get__id(it);
          // Inline function 'kotlin.collections.map' call
          var this_0 = $this$remember.faj(this.sj3_1);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var _iterator__ex2g4s = this_0.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$24 = item.z7a_1;
            destination.v(tmp$ret$24);
          }
          var tmp$ret$29 = xDataClassPathInsideSet(tmp_1, toSet(destination));
          return $this$remember.baj(tmp.feo(new (Query())(tmp$ret$29)));
        });
      }
      ucv() {
        return this.mj3_1;
      }
      ud6(_this__u8e3s4) {
        return _this__u8e3s4.jbb(sizeConstraints(_this__u8e3s4, VOID, get_AppDimensions().eg2_1), projectList(_this__u8e3s4, ProjectLens_Customer_getInstance(), this.sj3_1, this.tj3_1, this.pj3_1));
      }
    }
    initMetadataForClass($, 'ClientProjects', ClientProjects, VOID, [Page()]);
    ClientProjectsClass = $;
  }
  return ClientProjectsClass;
}
//region block: exports
export {
  ClientProjects as ClientProjectsuhqipbst20fz,
};
//endregion

//# sourceMappingURL=ClientProjects.mjs.map
